import { useUpdateUserSettings } from 'features/user';
import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Filter } from 'shared/assets/icons';
import { IconButton } from 'shared/components/ui/icon-button';
import {
  PopupMenu,
  PopupMenuList,
  PopupMenuListItem,
  PopupMenuToggle,
} from 'shared/components/ui/popup-menu';
import { useOpenMenu } from 'shared/hooks/use-open-menu';
import { useUser } from 'shared/hooks/use-user';

export const ExtraOptionsMenu: React.FC = () => {
  const { t } = useTranslation();
  const buttonRef = useRef<HTMLButtonElement>(null);
  const { menuOpen, openMenu, closeMenu } = useOpenMenu();

  const user = useUser();
  const updateUserSettings = useUpdateUserSettings();
  const showCompletedGoals =
    user?.settings?.goalsOverview?.roadmap?.showCompletedGoals ?? true;

  const onShowCompletedGoals = (value: boolean) => {
    updateUserSettings({
      goalsOverview: { roadmap: { showCompletedGoals: value } },
    });
  };

  return (
    <>
      <IconButton
        ref={buttonRef}
        icon={Filter}
        onClick={openMenu}
        highlighted={menuOpen}
        preventDrag
      />
      {menuOpen && (
        <PopupMenu
          referenceElement={buttonRef}
          onOutside={closeMenu}
          position="bottom-end"
        >
          <PopupMenuList>
            <PopupMenuListItem>
              <PopupMenuToggle
                label={t('general.labels.goals.show-completed-goals')}
                checked={showCompletedGoals}
                onChange={onShowCompletedGoals}
              />
            </PopupMenuListItem>
          </PopupMenuList>
        </PopupMenu>
      )}
    </>
  );
};
